import { useEffect } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function TermsModal({ isOpen, onClose }: Props) {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-2xl w-full max-w-[640px] max-h-[85vh] flex flex-col mx-4 animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-achromatic-100">
          <h2 className="text-lg font-extrabold text-achromatic-900">이용약관</h2>
          <button onClick={onClose} className="text-achromatic-400 hover:text-achromatic-600 transition-colors text-xl leading-none">✕</button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-5 text-[13px] text-achromatic-600 leading-[1.8]">
          <p className="text-xs text-achromatic-400 mb-4">시행일: 2025년 1월 1일</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제1조 (목적)</h3>
          <p className="mb-4">
            본 약관은 주식회사 젤리펀치(이하 "회사")가 운영하는 Tipot 플랫폼(이하 "서비스")의 이용 조건 및 절차,
            회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
          </p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제2조 (정의)</h3>
          <p className="mb-1">① "서비스"란 회사가 제공하는 온라인 시간/경험 거래 중개 플랫폼을 말합니다.</p>
          <p className="mb-1">② "이용자"란 본 약관에 따라 서비스를 이용하는 모든 회원을 말합니다.</p>
          <p className="mb-1">③ "호스트(크리에이터)"란 서비스에 시간·경험 상품을 등록하여 판매하는 이용자를 말합니다.</p>
          <p className="mb-4">④ "게스트"란 호스트가 등록한 상품을 구매하는 이용자를 말합니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제3조 (약관의 효력 및 변경)</h3>
          <p className="mb-1">① 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공시함으로써 효력이 발생합니다.</p>
          <p className="mb-4">② 회사는 관련 법령에 위배되지 않는 범위에서 본 약관을 변경할 수 있으며, 변경 시 적용일자 7일 전부터 공지합니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제4조 (회원 가입 및 탈퇴)</h3>
          <p className="mb-1">① 회원 가입은 카카오 소셜 로그인을 통해 이루어지며, 본 약관 및 개인정보 처리방침에 동의한 것으로 간주됩니다.</p>
          <p className="mb-1">② 회원은 언제든지 서비스 내 설정에서 탈퇴를 요청할 수 있습니다.</p>
          <p className="mb-4">③ 탈퇴 시 미정산 잔액이 있을 경우, 정산 완료 후 탈퇴가 처리됩니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제5조 (서비스 이용)</h3>
          <p className="mb-1">① 서비스는 호스트가 등록한 시간·경험 상품을 게스트가 예약·결제하고, 결제 완료 시 외부 접속 링크(Zoom, 디스코드 등)를 제공받는 구조입니다.</p>
          <p className="mb-1">② 회사는 서비스 내부에 채팅, 화상 통화 등의 커뮤니케이션 기능을 제공하지 않으며, 외부 링크 전달(라우팅) 역할만 수행합니다.</p>
          <p className="mb-4">③ 서비스 이용 중 발생하는 외부 플랫폼(Zoom, 디스코드 등)에서의 문제에 대해 회사는 책임을 지지 않습니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제6조 (결제 및 정산)</h3>
          <p className="mb-1">① 게스트의 결제 대금은 서비스 완료 시까지 회사가 에스크로 방식으로 안전하게 보관합니다.</p>
          <p className="mb-1">② 서비스 완료(양측 확인) 후 호스트에게 정산되며, 플랫폼 수수료 15%가 차감됩니다.</p>
          <p className="mb-4">③ 정산은 호스트가 등록한 계좌로 출금 요청 시 처리됩니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제7조 (취소 및 환불)</h3>
          <p className="mb-1">① 예약된 서비스는 시작 시간 24시간 전까지 무료 취소가 가능합니다.</p>
          <p className="mb-1">② 24시간 이내 취소 시 수수료가 부과될 수 있습니다.</p>
          <p className="mb-4">③ 호스트의 일방적 취소 시 게스트에게 전액 환불되며, 호스트에게 패널티가 부과될 수 있습니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제8조 (금지 행위)</h3>
          <p className="mb-1">이용자는 다음 행위를 해서는 안 됩니다:</p>
          <p className="mb-1 pl-3">1. 타인의 정보를 도용하거나 허위 정보를 등록하는 행위</p>
          <p className="mb-1 pl-3">2. 불법적이거나 미풍양속에 반하는 서비스를 등록하는 행위</p>
          <p className="mb-1 pl-3">3. 서비스 외부에서 직접 거래를 유도하는 행위</p>
          <p className="mb-1 pl-3">4. 다른 이용자에게 불쾌감을 주거나 위협하는 행위</p>
          <p className="mb-4 pl-3">5. 서비스의 정상적인 운영을 방해하는 행위</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제9조 (회사의 의무)</h3>
          <p className="mb-1">① 회사는 관련 법령과 본 약관이 금지하는 행위를 하지 않으며, 지속적·안정적으로 서비스를 제공하기 위해 노력합니다.</p>
          <p className="mb-4">② 회사는 이용자의 개인정보를 안전하게 관리하며, 개인정보 처리방침에 따라 처리합니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제10조 (면책)</h3>
          <p className="mb-1">① 회사는 천재지변, 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.</p>
          <p className="mb-1">② 이용자 간의 거래에서 발생하는 분쟁에 대해 회사는 중재 역할을 수행하나, 최종 책임은 당사자에게 있습니다.</p>
          <p className="mb-4">③ 회사는 외부 플랫폼의 장애, 보안 문제 등에 대해 책임을 지지 않습니다.</p>

          <h3 className="text-sm font-bold text-achromatic-900 mb-2">제11조 (분쟁 해결)</h3>
          <p className="mb-1">① 본 약관에 관한 분쟁은 대한민국 법률을 준거법으로 합니다.</p>
          <p className="mb-4">② 서비스 이용과 관련된 소송은 회사 소재지 관할 법원을 전속관할로 합니다.</p>

          <div className="bg-achromatic-50 rounded-xl p-4 mt-4">
            <p className="text-xs text-achromatic-500">
              <strong>주식회사 젤리펀치</strong><br />
              문의: help@jellypunch.com
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-achromatic-100">
          <button
            onClick={onClose}
            className="w-full py-3 bg-primary-500 text-white rounded-xl text-sm font-bold hover:bg-primary-600 transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
